import { Injectable } from '@angular/core';
import { SETTINGS } from '../../../core/config/common.settings';
import { HttpClient } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class RegistrationFormService {
  constructor(private http: HttpClient, private message: NzMessageService) {}

  registration(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${SETTINGS.BASE_API}/admin/register`, payload).subscribe({
        next: (response: any) => {
          this.message.create(
            'success',
            'Your registration success.Please login your Itinerary Account'
          );
          resolve(response);
        },
        error: (error: any) => {
          if (error.status === 403 || error === 403) {
          }
          if (error?.error?.message === SETTINGS.COMMON_ERROR.ORG_EMAIL_EXISTS) {
            this.message.create("error", "This email already exists");
          }else{
            this.message.create("error", "Your registration not successful");
          }
          reject(error.error.message);
        },
      });
    });
  }
}
